// Fonte di verità condivisa per il funnel lead magnet "Cremoso al Limone".
// Usata dal client (route + form), dal server (email di consegna) e dai meta SEO,
// così cambiare l'URL della landing è una modifica in un punto solo.
//
// ⚠️ La landing a pagamento /primo-appuntamento NON fa parte di questo funnel:
// resta online e invariata (traffico caldo + destinazione dei follow-up).

/** Landing pubblica del lead magnet (duplicata da /primo-appuntamento). */
export const LEAD_MAGNET_PATH = "/ricetta-omaggio";

/** Pagina di ringraziamento post-invio (noindex). */
export const LEAD_MAGNET_THANKYOU_PATH = "/grazie-ricetta";

/** Ancora della sezione form, usata dalle CTA interne alla landing. */
export const LEAD_MAGNET_FORM_ANCHOR = "#ricetta";

/**
 * Versione del testo dei consensi mostrato nel form.
 * Va incrementata a ogni modifica delle formule di consenso: viene salvata
 * insieme al lead per poter provare *quale* testo l'utente ha accettato.
 */
export const LEAD_MAGNET_CONSENT_VERSION = "2026-07-31_v1";

/** Nome del lead magnet, usato come `source` sui lead salvati e nei log. */
export const LEAD_MAGNET_SOURCE = "cremoso-al-limone";
